import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.epsilon";
import "core-js/modules/es6.object.is";
import _typeof from "/home/jenkins/workspace/procure-web-seven-test/node_modules/@babel/runtime-corejs2/helpers/esm/typeof";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/jenkins/workspace/procure-web-seven-test/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.regexp.split";
import _toConsumableArray from "/home/jenkins/workspace/procure-web-seven-test/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "/home/jenkins/workspace/procure-web-seven-test/node_modules/core-js/modules/es6.promise.js";
import "/home/jenkins/workspace/procure-web-seven-test/node_modules/core-js/modules/es6.symbol.js";
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import "./lib/config";
import { parse } from 'json-bigint';
// import Vuetify from 'vuetify'
import Vuetify from 'vuetify/lib';
import dataV from '@jiaminghi/data-view';
Vue.use(dataV);
import UmyUi from 'umy-ui';
import 'umy-ui/lib/theme-chalk/index.css'; // 引入样式
Vue.use(UmyUi);
import VueECharts from 'vue-echarts/components/ECharts';
import 'element-ui/lib/theme-chalk/base.css';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import axios from "axios";
import Lib from "./assets/js/Lib";
import i18n from "./i18n";
import App from "./App";
import router from "./router";
import store from "./store";
// import htmlToPdf from './assets/js/htmlToPdf'
import uploader from 'vue-simple-uploader';
import VueBaiduMap from "vue-baidu-map";
import 'viewerjs/dist/viewer.min.css';
import Viewer from 'v-viewer';
import vuescroll from 'vuescroll/dist/vuescroll-native';
import VueQuillEditor from 'vue-quill-editor';
// import Print from 'print-js'
import common from "../public/static/js/common";
import noPermissionImg from "./components/common/noPermissionImg";
import breadCrumbs from "./components/common/breadCrumbs";
import exportExcel from "./components/common/exportExcel.vue";
import measureUnit from "./components/common/measureUnit.vue";
import noData from "./components/common/noData";
import blueCard from "./components/common/blueCard";
import selectedDateRange from "./components/common/selectedDateRange";
import selectedDateTimeRange from "./components/common/selectedDateTimeRange";
import timeFormat from "./components/common/selectedDateRange/timeFormat.js";
Vue.prototype.$timeFormat = timeFormat;
import dateFormat from "./utils/DateUtil.js";
Vue.prototype.$dateFormat = dateFormat;
import monthExplain from '@/components/common/monthExplain.vue';
import '@/icons'; // icon
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import "./assets/js/vuetify";
import "./assets/css/common.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
NProgress.configure({
  ease: 'ease',
  speed: 500,
  showSpinner: false
});
import "./filter/vueFilter";
import Print from 'vue-print-nb';
window.Lib = Lib;
import throttleAndDebounce from "./utils/throttleAndDebounce.js";
Vue.prototype.$debounce = throttleAndDebounce.debounce;
Vue.prototype.$throttle = throttleAndDebounce.throttle;
Vue.prototype.$common = common;
Vue.component('chart', VueECharts);
Vue.component('breadCrumbs', breadCrumbs);
Vue.component('noData', noData);
Vue.component('blueCard', blueCard);
Vue.component('month-explain', monthExplain);
Vue.component('noPermissionImg', noPermissionImg);
Vue.component('exportExcel', exportExcel);
Vue.component('measureUnit', measureUnit);
Vue.component('selected-date-range', selectedDateRange);
Vue.component('selected-date-time-range', selectedDateTimeRange);

// Vue.use(htmlToPdf);
Vue.use(Vuetify);
Vue.use(uploader);
Vue.use(Viewer);
Vue.use(vuescroll);
Vue.use(VueQuillEditor);
Vue.use(Print);
Vue.use(ElementUI);
Vue.config.devtools = process.env.VUE_APP_ENV !== 'prod';
Vue.use(VueBaiduMap, {
  ak: "YxURfHFLhpkljqf0E9Dcs4Ia46LpUIS9"
});
window.VueBaiduMap = VueBaiduMap;

/**
 * easytable
 * 整体映入
 * 官网地址
 * http://huangshuwei.gitee.io/vue-easytable/#/zh/doc/start
 */

// 引入样式
import "vue-easytable/libs/theme-default/index.css";
// 引入组件库
import VueEasytable from "vue-easytable";
Vue.use(VueEasytable);
Vue.config.productionTip = false;
new Vue({
  router: router,
  store: store,
  i18n: i18n,
  render: function render(h) {
    return h(App);
  }
}).$mount("#app");
Vue.directive('has', {
  inserted: function inserted(el, binding, vnode) {
    // 获取按钮权限
    if (!Vue.prototype.$_has(binding.value)) {
      el.remove();
    } else {
      if (el.lastChild.className === "errPage-container") {
        el.lastChild.remove();
      }
    }
  }
});
Vue.prototype.$parseJsonString = function (jsonString) {
  return parse(jsonString);
};
Vue.prototype.$isNull = function (string) {
  if (string === null || string === undefined || string === "") {
    return '/';
  } else {
    return string;
  }
};

//获取待办
Vue.prototype.getUnreadMsgCnt = function () {
  var vm = this;
  Lib.M.ajax({
    'method': "get",
    'show': "asd",
    'url': 'jpush/getJMessage/' + JSON.parse(sessionStorage.getItem("data")).userId,
    'params': {
      isRead: 0,
      pageNum: 1,
      pageSize: 10
    },
    'success': function success(data) {
      vm.$store.dispatch("dispatchGetAllCount", data.obj.allCount);
      vm.$store.dispatch("dispatchGetMessageListCount", data.obj.messageListCount);
      vm.$store.dispatch("dispatchGetTodoListCount", data.obj.todoListCount);
      // 注意 dispatchListSwitch中既有通知 也有待办 使用type 0-查通知总数，1-查待办总数 骚操作
      vm.$store.dispatch("dispatchListSwitch", data.obj.data);
    },
    "error": function error(data) {}
  });
};
Vue.prototype.$removeEmptyAttr = function (obj) {
  var _this = this;
  if (!obj.children || !obj.children.length) {
    delete obj.children;
    return;
  }
  obj.children.forEach(function (val) {
    _this.$removeEmptyAttr(val);
  });
};
Vue.prototype.$digitUppercase = function (price) {
  var fraction = ['角', '分'];
  var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  var unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
  var num = Math.abs(price);
  var s = '';
  fraction.forEach(function (item, index) {
    s += (digit[Math.floor(num * 10 * Math.pow(10, index)) % 10] + item).replace(/零./, '');
  });
  s = s || '整';
  num = Math.floor(num);
  for (var i = 0; i < unit[0].length && num > 0; i += 1) {
    var p = '';
    for (var j = 0; j < unit[1].length && num > 0; j += 1) {
      p = digit[num % 10] + unit[1][j] + p;
      num = Math.floor(num / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
};
Vue.directive("popover", function (el, binding) {
  var value = binding.value;
  console.log(binding);
  var childrenDiv = document.createElement("div");
  el.setAttribute("style", "cursor: pointer;");
  el.addEventListener("mouseenter", function (e) {
    e.preventDefault();
    if (el.childNodes[0].className != "v-alert error") {
      var childNodes = el.getElementsByTagName("div");
      if (childNodes.length) {
        for (var i = 0; i < childNodes.length; i++) {
          el.removeChild(childNodes[i]);
        }
      }
      childrenDiv.setAttribute("style", "display:none;");
      childrenDiv.setAttribute("style", "word-break:normal;white-space: normal;display:flex;z-index:700;position:absolute;max-width:200px;padding:10px;background:#fff;border:1px solid #ddd;border-radius:5px;flex-direction: wrap;");
      if (value) {
        childrenDiv.innerHTML = value;
      } else {
        childrenDiv.innerHTML = "暂无";
      }
      el.appendChild(childrenDiv);
    }
  });
  el.addEventListener("mouseleave", function (e) {
    e.preventDefault();
    childrenDiv.setAttribute("style", "display:none;");
  });
});

// 展平数组
function flatArr(arr) {
  var res = [];
  arr.forEach(function (item) {
    res.push(item);
    if (item.children.length) {
      res.push.apply(res, _toConsumableArray(flatArr(item.children)));
    }
  });
  return res;
}

// 权限检查方法
Vue.prototype.$_has = function (value) {
  var isExist = false;
  var btnPermissionsStr = JSON.parse(sessionStorage.getItem("btnPermissions"));
  // console.log(btnPermissionsStr);
  if (btnPermissionsStr == undefined || btnPermissionsStr == null || btnPermissionsStr.length == 0) {
    return isExist;
  }
  btnPermissionsStr = flatArr(btnPermissionsStr);
  if (value.indexOf(',') != -1) {
    value = value.split(',');
  }
  if (typeof value === 'string') {
    isExist = btnPermissionsStr.some(function (item, index, arr) {
      return item.titleEng === value;
    });
  } else {
    var flat = 0;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
      var _loop = function _loop() {
        var item = _step.value;
        if (value.some(function (val) {
          return val === item.titleEng;
        })) {
          flat++;
        }
      };
      for (var _iterator = btnPermissionsStr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    if (flat === value.length) {
      isExist = true;
    }
  }
  return isExist;
};

// Vue.prototype.Print = Print;

var upload = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  //这里配置你自己的url
  timeout: 50000
});
Vue.prototype.$upload = upload;
Vue.prototype.$axios = axios;

/**
 * 在vue原型链上增加get post put delete四种请求方式
 */
Vue.prototype.$get = Lib.M.get;
Vue.prototype.$post = Lib.M.postJson;
Vue.prototype.$put = Lib.M.putJson;
Vue.prototype.$deletes = Lib.M.delete;
Vue.prototype.$deleteList = Lib.M.deleteList;
Vue.prototype.$download = Lib.M.download;
Vue.prototype.$getDownload = Lib.M.getDownload;
Vue.prototype.$postUpload = Lib.M.upload;
Vue.prototype.$getWithOutLoading = Lib.M.getWithOutLoading;
Vue.prototype.$postWithOutLoading = Lib.M.postWithOutLoadingJson;
router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // let sessionId=sessionStorage.getItem('sessionId');
            selectBtn(to.name);
            console.log("验证");
            if (to.matched.some(function (m) {
              return m.meta.authe;
            })) {
              if (store.state.isLogin || sessionStorage.getItem("procureIsLogin")) {
                NProgress.start();
                next();
              } else {
                next({
                  path: "/"
                });
              }
            } else {
              next();
            }
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function (transition) {
  NProgress.done();
});
function selectBtn(router) {
  var data = JSON.parse(sessionStorage.getItem('data'));
  var permissions = JSON.parse(sessionStorage.getItem("permission"));
  selectChild(permissions, router);
}

//按钮级别权限，router必须要写其点进去里面的router，否则找不到；
function selectChild(permissions, router) {
  for (var key in permissions) {
    if (permissions[key].children.length) {
      if (router === permissions[key].router) {
        sessionStorage.setItem("btnPermissions", JSON.stringify(permissions[key].children));
      } else {
        selectChild(permissions[key].children, router);
      }
    }
  }
}
Vue.prototype.showSnackbar = function () {
  var _this2 = this;
  this.snackbar = true;
  if (this.snackTimer) {
    clearTimeout(this.snackTimer);
  }
  this.snackTimer = setTimeout(function () {
    _this2.snackbar = false;
  }, 2000);
};
Vue.prototype.hideSnackbar = function () {
  this.snackbar = false;
  if (this.snackTimer) {
    clearTimeout(this.snackTimer);
  }
};
Vue.prototype.fileToBase64 = function (raw) {
  console.log(raw);
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(raw);
    reader.onload = function (e) {
      if (e.target.readyState == 2) {
        resolve(e.target.result);
      } else {
        reject();
      }
    };
  });
};
Vue.prototype.filterDept = function (deptId) {
  if (deptId == "dept-20180629152513-zou9tcdt" || deptId == undefined) {
    return "";
  } else {
    return deptId;
  }
};
Vue.prototype.urlToBase64 = function (url, outputFormat) {
  return new Promise(function (resolve, reject) {
    var canvas = document.createElement('CANVAS'),
      ctx = canvas.getContext('2d'),
      img = new Image();
    var dataURL;
    img.crossOrigin = 'Anonymous';
    img.src = url;
    img.onload = function () {
      canvas.height = img.height;
      canvas.width = img.width;
      ctx.drawImage(img, 0, 0);
      dataURL = canvas.toDataURL(outputFormat || 'image/png');
      canvas = null;
      resolve(dataURL);
    };
  });
};
Vue.prototype.fileToRaw = function (url, imageName) {
  // imageName一定要带上后缀
  var p = new Promise(function (resolve, reject) {
    var blob = null;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.setRequestHeader('Accept', 'image/jpeg');
    xhr.responseType = "blob";
    xhr.onload = function () {
      blob = xhr.response;
      var imgFile = new File([blob], imageName, {
        type: 'image/jpeg'
      });
      resolve(imgFile);
    };
    xhr.send();
  });
  return p;
};
Vue.prototype.compress = function (file) {
  var isBase64 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var imgType = arguments.length > 2 ? arguments[2] : undefined;
  var isJPG = false;
  console.log(imgType);
  if (imgType) {
    for (var key in imgType) {
      if (file.type == imgType[key]) {
        isJPG = true;
      }
    }
    if (!isJPG) {
      this.$message.warning('上传的图片只能是 JPG/png 格式!');
      return false;
    }
  }
  var reader = new FileReader();
  //将图片转成base64格式
  reader.readAsDataURL(file);
  return new Promise(function (resolve, reject) {
    reader.onloadend = function () {
      var result = this.result;
      var img = new Image();
      img.src = result;
      console.log("********未压缩前的图片大小********");
      console.log(result.length);
      img.onload = function () {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext('2d');
        //瓦片canvas
        var tCanvas = document.createElement("canvas");
        var tctx = tCanvas.getContext("2d");
        var initSize = img.src.length;
        var width = img.width;
        var height = img.height;
        //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        var ratio;
        if ((ratio = width * height / 4000000) > 1) {
          console.log("大于400万像素");
          ratio = Math.sqrt(ratio);
          width /= ratio;
          height /= ratio;
        } else {
          ratio = 1;
        }
        canvas.width = width;
        canvas.height = height;
        //        铺底色
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //如果图片像素大于100万则使用瓦片绘制
        var count;
        if ((count = width * height / 1000000) > 1) {
          console.log("超过100W像素");
          count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
          //            计算每块瓦片的宽和高
          var nw = ~~(width / count);
          var nh = ~~(height / count);
          tCanvas.width = nw;
          tCanvas.height = nh;
          for (var i = 0; i < count; i++) {
            for (var j = 0; j < count; j++) {
              tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
              ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
            }
          }
        } else {
          ctx.drawImage(img, 0, 0, width, height);
        }
        //进行最小压缩
        var ndata = canvas.toDataURL('image/jpeg', 0.3);
        console.log('压缩前：' + initSize);
        console.log('压缩后：' + ndata.length);
        console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        console.log('base64为' + ndata);
        if (isBase64) {
          resolve(ndata); //返回base64
        } else {
          var arr = ndata.split(',');
          var mime = arr[0].match(/:(.*?);/)[1];
          console.log(mime);
          var bstr = atob(arr[1]);
          var n = bstr.length;
          var u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var returnFile = new Blob([u8arr], {
            type: mime
          });
          returnFile.lastModifiedDate = new Date();
          returnFile.name = file.name;
          resolve(returnFile); //返回文件raw
        }
      };
    };
  });
};
function objectKeyIsEmpty(obj) {
  var empty = null;
  for (var _key in obj) {
    if (obj.hasOwnProperty(_key)) {
      if (obj[_key] === null || obj[_key] === '') {
        empty = true;
      } else {
        empty = false;
        break;
      }
    }
  }
  return empty;
}
Vue.prototype.makeFormData = function makeFormData(obj) {
  var fd = new FormData();
  for (var o in obj) {
    fd.append(o, obj[o]);
  }
  return fd;
};
Vue.prototype.deepCopy = function (obj) {
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  //判断拷贝的要进行深拷贝的是数组还是对象，是数组的话进行数组拷贝，对象的话进行对象拷贝
  var objClone = Array.isArray(obj) ? [] : {};
  //进行深拷贝的不能为空，并且是对象或者是
  if (obj && _typeof(obj) === "object") {
    for (key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] && _typeof(obj[key]) === "object") {
          objClone[key] = deepClone1(obj[key]);
        } else {
          objClone[key] = obj[key];
        }
      }
    }
  }
  return objClone;
};
Vue.prototype.$getEntpName = function (branchUnitName, projectUnitName) {
  var entpName = '';
  if (projectUnitName) {
    entpName = projectUnitName;
  } else if (branchUnitName) {
    entpName = branchUnitName;
  } else {
    entpName = this.$config.empNikeName;
  }
  return entpName;
};
// 得到unitId
Vue.prototype.$getUnitId = function () {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!arr.length) return '';
  var unitId = arr[arr.length - 1];
  return unitId == 'dept-20180629152513-zou9tcdt' ? '' : unitId;
};

// 得到unitId
Vue.prototype.$getUnitId = function () {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!arr.length) return '';
  var unitId = arr[arr.length - 1];
  return unitId == 'dept-20180629152513-zou9tcdt' ? '' : unitId;
};
/**
 * 保留小数点几位数, 自动补零, 四舍五入
* @param num: 数值
* @param digit: 小数点后位数
* @returns string
*/
Vue.prototype.$myFixed = function myFixed(num, digit) {
  if (Object.is(parseFloat(num), NaN)) {
    return console.log("\u4F20\u5165\u7684\u503C\uFF1A".concat(num, "\u4E0D\u662F\u4E00\u4E2A\u6570\u5B57"));
  }
  num = parseFloat(num);
  return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit).replace(/\.?0+$/, '');
};
Vue.prototype.getUnitName = function (branchUnitName, projectUnitName) {
  if (projectUnitName) {
    return branchUnitName + projectUnitName;
  } else if (branchUnitName) {
    return branchUnitName;
  }
  return '工程局';
};
Vue.prototype.getUnitNameNew = function (branchUnitName, projectUnitName) {
  if (projectUnitName) {
    return branchUnitName + projectUnitName;
  } else if (branchUnitName) {
    return branchUnitName;
  }
  return '水电七局';
};
Vue.prototype.getAllUnitName = function (branchUnitName, projectUnitName) {
  var unitName = '水电七局';
  if (branchUnitName) {
    unitName += branchUnitName;
  }
  if (projectUnitName) {
    unitName += projectUnitName;
  }
  return unitName;
};

// 延时执行函数
Vue.prototype.$delayExecute = function (fn, condition) {
  var _this3 = this;
  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 50;
  if (count <= 0) {
    return;
  }
  if (condition()) {
    fn();
  } else {
    setTimeout(function () {
      _this3.$delayExecute(fn, condition, delay, count - 1);
    }, delay);
  }
};
Vue.prototype.compare = function (property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value2 - value1;
  };
};
Vue.prototype.compareAsc = function (property) {
  return function (a, b) {
    var value1 = a[property];
    var value2 = b[property];
    return value1 - value2;
  };
};
String.prototype.endWith = function (endStr) {
  var d = this.length - endStr.length;
  return d >= 0 && this.lastIndexOf(endStr) == d;
};
Date.prototype.format = function () {
  var s = '';
  var mouth = this.getMonth() + 1 >= 10 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1);
  var day = this.getDate() >= 10 ? this.getDate() : '0' + this.getDate();
  var hours = this.getHours() >= 10 ? this.getHours() : "0" + this.getHours();
  var minutes = this.getMinutes() >= 10 ? this.getMinutes() : "0" + this.getMinutes();
  var seconds = this.getSeconds() >= 10 ? this.getSeconds() : "0" + this.getSeconds();
  s += this.getFullYear() + '年'; // 获取年份。
  s += mouth + "月"; // 获取月份。
  s += day + "日"; // 获取日。
  return s; // 返回日期。
};
Date.prototype.formatYYYYMMDDhhmmss = function () {
  var s = '';
  var mouth = this.getMonth() + 1 >= 10 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1);
  var day = this.getDate() >= 10 ? this.getDate() : '0' + this.getDate();
  var hours = this.getHours() >= 10 ? this.getHours() : '0' + this.getHours();
  var minutes = this.getMinutes() >= 10 ? this.getMinutes() : '0' + this.getMinutes();
  var seconds = this.getSeconds() >= 10 ? this.getSeconds() : '0' + this.getSeconds();
  s += this.getFullYear() + '-'; // 获取年份。
  s += mouth + '-'; // 获取月份。
  s += day + ' '; // 获取日。
  s += hours + ':';
  s += minutes + ':';
  s += seconds;
  return s; // 返回日期。
};
Vue.prototype.GetDateDiff = function (startTime, endTime, diffType) {
  //将xxxx-xx-xx的时间格式，转换为 xxxx/xx/xx的格式

  //将计算间隔类性字符转换为小写
  diffType = diffType.toLowerCase();
  var sTime = new Date(startTime); //开始时间
  var eTime = new Date(endTime); //结束时间
  //作为除数的数字
  var timeType = 1;
  switch (diffType) {
    case "second":
      timeType = 1000;
      break;
    case "minute":
      timeType = 1000 * 60;
      break;
    case "hour":
      timeType = 1000 * 3600;
      break;
    case "day":
      timeType = 1000 * 3600 * 24;
      break;
    default:
      break;
  }
  return parseInt((eTime.getTime() - sTime.getTime()) / parseInt(timeType));
};
Vue.prototype.$checkAudit = checkAudit;
function checkAudit(auditRecordVOList, pUser) {
  for (var i = 0; auditRecordVOList.length > i; i++) {
    if (auditRecordVOList[i].userId === pUser.userId) {
      if (auditRecordVOList[i].auditStatus === 2) {
        return true;
      }
    }
  }
  return false;
}
Vue.prototype.getOneUnitName = function (branchUnitName, projectUnitName) {
  if (projectUnitName) {
    return projectUnitName;
  } else if (branchUnitName) {
    return branchUnitName;
  }
  return '水电七局';
};
Vue.prototype.getDeptName = function (projectUnitName, branchUnitName) {
  if (projectUnitName) {
    return branchUnitName + projectUnitName;
  } else if (branchUnitName) {
    return branchUnitName;
  }
  return '水电七局';
};
Vue.prototype.setSrc = function (fileName) {
  if (fileName.endsWith(".pdf")) {
    return require("@/assets/img/PDF.png");
  } else if (fileName.endsWith(".docx") || fileName.endsWith(".doc")) {
    return require("@/assets/img/word.png");
  } else if (fileName.endsWith(".xlsx") || fileName.endsWith(".xls")) {
    return require("@/assets/img/xsl.png");
  } else if (fileName.endsWith(".zip") || fileName.endsWith(".rar")) {
    return require("@/assets/img/file.png");
  } else {
    return require("@/assets/img/default.png");
  }
}, Vue.prototype.$pageSizes = [10, 20, 50, 100];
var priceReg1 = /(^\d{1,}$)|(^\d{1,}\.\d{0,2}$)/;
var priceReg2 = /(^\d{1,}$)|(^\d{1,}\.\d{1,2}$)/;
var priceReg3 = /(^[0-9]*$)/;
Vue.mixin({
  methods: {
    // 表格空内容显示暂无
    $tableIsEmpty: function $tableIsEmpty(row, column, cellValue, index) {
      return cellValue == null || cellValue == undefined || cellValue == '' ? '暂无' : cellValue;
    },
    $tableInputNumber: function $tableInputNumber(data, prop, index) {
      var val = this[data][index][prop];
      if (!priceReg1.test(val)) {
        this[data][index][prop] = val.substring(0, val.length - 1);
      }
    },
    $tableBlurNumber: function $tableBlurNumber(data, prop, index) {
      var val = this[data][index][prop];
      if (!priceReg2.test(val)) {
        this[data][index][prop] = val.substring(0, val.length - 1);
      }
    },
    //必须正整数
    $mustPositiveInteger: function $mustPositiveInteger(data, prop, index) {
      var val = this[data][index][prop];
      if (!priceReg3.test(val)) {
        // this.$message.error("请输入正整数")
        this[data][index][prop] = val.substring(0, val.length - 1);
      }
    }
  }
});

// 设备定位图标
import getVehicleIcon from "./assets/js/vehicleIcon.js";
Vue.prototype.$getVehicleIcon = getVehicleIcon;